import { render, staticRenderFns } from "./LoginPopup.vue?vue&type=template&id=0506c61a&scoped=true"
import script from "./LoginPopup.vue?vue&type=script&lang=js"
export * from "./LoginPopup.vue?vue&type=script&lang=js"
import style0 from "./LoginPopup.vue?vue&type=style&index=0&id=0506c61a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0506c61a",
  null
  
)

export default component.exports